import { makeStyles } from '@material-ui/core';
import { memo } from 'react';

import { ListCarDTO } from '../modules/generated/api';

import { PromotionIcon } from './PromotionIcon';

type PromotionsProps = {
  car: ListCarDTO;
};

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 2,
  },
});

const Promotions = ({ car: { promotions } }: PromotionsProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {/* Thermo is listed as a promotion but its actually an equipment. So we filter it out here. */}
      {/* VVJ is listed as a promotion but its actually a virtual source. So we filter it out here. */}
      {(promotions || [])
        .filter((promo) => promo !== 'THERMO')
        .filter((promo) => promo !== 'VVJ')
        .map((promotion) => (
          <PromotionIcon
            key={promotion}
            promotion={promotion}
            highlight={['STELLPLATZ', 'AFTERSHOW'].includes(promotion)}
          />
        ))}
    </div>
  );
};

export default memo(Promotions);
